import React from "react";
import { useI18n } from "@/i18n/I18nProvider";

export default function LegalLayout({ title, updated, sections }) {
  const { t } = useI18n();
  return (
    <main className="dma-legal">
      <div className="dma-legal__inner">
        <header className="dma-legal__head">
          <span className="dma-legal__eyebrow">{t("brand.name")}</span>
          <h1 className="dma-legal__title">{title}</h1>
          <p className="dma-legal__updated">{updated}</p>
        </header>
        <article className="dma-legal__content">
          {sections.map((s, i) => (
            <section key={i} className="dma-legal__section">
              {s.title && <h2>{s.title}</h2>}
              <p>{s.text}</p>
            </section>
          ))}
        </article>
      </div>
    </main>
  );
}
